.flip-logo{width:64px;height:41px}
/*# sourceMappingURL=flip-logo.component-EIZXWXM4.css.map */
